module.exports = __webpack_public_path__ + "static/media/heart-red-filled.84103b7f.svg";